import { render, staticRenderFns } from "./DeleteMedicationAlert.vue?vue&type=template&id=1368ed7d"
import script from "./DeleteMedicationAlert.vue?vue&type=script&lang=js"
export * from "./DeleteMedicationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports